<template>
  <div :class="fullScreenClass">
    <vue-lottie-player
      class="m-auto"
      :style="style"
      loop
      name="spinner"
      path="https://assets3.lottiefiles.com/packages/lf20_p6ywl1q2.json"
    />
  </div>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "Spinner",
  components: { VueLottiePlayer },
  props: {
    size: {
      type: String,
      default: "fullscreen",
    },
  },
  computed: {
    fullScreenClass() {
      const { size } = this;
      if (size === "fullscreen") return "w-100 h-100";
      return "";
    },
    style() {
      const { size } = this;
      if (size === "sm") return "width: 40px; height: 40px;";
      return "";
    },
  },
};
</script>

<style scoped></style>
